<template>
  <v-chip
    :color="color"
    :size="size"
    label
    class="font-weight-medium"
  >
    {{ label }}
  </v-chip>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import type { AiReportStatus } from "@/api/ApiAiReport";

export default defineComponent({
  name: "AiReportStatusChip",
  props: {
    status: {
      type: String as PropType<AiReportStatus>,
      required: true,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  computed: {
    label(): string {
      if (this.status === "published") return "公開済";
      if (this.status === "draft") return "下書き";
      return "未作成";
    },
    color(): string {
      if (this.status === "published") return "primary";
      if (this.status === "draft") return "amber";
      return "grey-lighten-1";
    },
  },
});
</script>
